import React from 'react';
import { motion } from 'framer-motion';
import { Timer } from 'lucide-react';
export const TopBar = () => {
  return <motion.div initial={{
    y: -50
  }} animate={{
    y: 0
  }} className="sticky top-0 z-50 w-full px-4 py-2 text-sm font-medium text-center text-black bg-brand-gold" data-id="element-183">
      <div className="flex items-center justify-center gap-2" data-id="element-184">
        <Timer className="w-4 h-4" data-id="element-185" />
        <span data-id="element-186">
          🔥 Promoción por tiempo limitado: Últimos cupos a precio promocional
        </span>
      </div>
    </motion.div>;
};